import { Link } from "react-router-dom";
import { Heart, Plus } from "lucide-react";
import { useStore } from "../context/StoreContext";
import Coin from "./Coin";
import { toast } from "sonner";
import sfx from "../utils/sound";

const ProductCard = ({ product }) => {
  const { addToCart, toggleWishlist, wishlist } = useStore();
  const isFav = wishlist.includes(product.id);

  return (
    <div
      className="chunky-card pushable relative overflow-hidden flex flex-col"
      data-testid={`product-card-${product.id}`}
      style={{ borderColor: "#2b2b2b" }}
    >
      <button
        onClick={(e) => {
          e.preventDefault();
          toggleWishlist(product.id);
          sfx.fav();
          toast(isFav ? "Removed from wishlist" : "Added to wishlist 💖", {
            duration: 1400,
          });
        }}
        className="absolute top-3 right-3 z-10 rounded-full flex items-center justify-center"
        aria-label="Favorite"
        data-testid={`fav-btn-${product.id}`}
        style={{
          width: 44,
          height: 44,
          background: isFav ? "#F368E0" : "#fff",
          border: "3px solid #2b2b2b",
          boxShadow: "0 3px 0 #2b2b2b",
        }}
      >
        <Heart
          size={20}
          strokeWidth={3}
          color={isFav ? "white" : "#F368E0"}
          fill={isFav ? "white" : "none"}
        />
      </button>

      <Link
        to={`/product/${product.id}`}
        className="block"
        data-testid={`product-link-${product.id}`}
      >
        <div
          className="w-full flex items-center justify-center"
          style={{
            background: product.color + "22",
            height: 160,
            borderBottom: "3px solid #2b2b2b",
          }}
        >
          <span
            className="bob"
            style={{
              fontSize: 88,
              lineHeight: 1,
              filter: "drop-shadow(0 4px 0 rgba(0,0,0,0.15))",
            }}
            aria-hidden="true"
          >
            {product.emoji}
          </span>
        </div>
      </Link>

      <div className="p-4 flex flex-col gap-2 flex-1">
        <Link to={`/product/${product.id}`}>
          <h3
            className="font-display text-lg leading-tight"
            data-testid={`product-name-${product.id}`}
          >
            {product.name}
          </h3>
        </Link>
        <div className="flex items-center justify-between mt-auto pt-2">
          <div
            className="coin-pill text-sm"
            data-testid={`product-price-${product.id}`}
          >
            <Coin size={18} />
            {product.price}
          </div>
          <button
            onClick={() => {
              addToCart(product);
              sfx.add();
              toast(`Added ${product.name}!`, { duration: 1400 });
            }}
            className="btn-3d btn-sm btn-accent shrink-0"
            style={{ padding: "8px 12px" }}
            data-testid={`add-to-cart-${product.id}`}
          >
            <Plus size={18} strokeWidth={3} />
            <span className="hidden sm:inline">Add</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
